import loadCurrentShipTos from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTos";
import { getCurrentShipTosDataView } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import Select, { SelectProps } from "@insite/mobius/Select";
import { WorkOrderHistoryPageContext } from "@sonic/Pages/WorkOrderHistoryPage";
import { customerState } from "@sonic/Store/GemecoState";
import updateSearchFields from "@sonic/Store/Pages/WorkOrderHistory/Handlers/UpdateSearchFields";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: customerState) => {
    return {
        currentShipTosDataView: getCurrentShipTosDataView(state),
        parameter: state.workOrderHistoryPageReducer.getOrdersParameter,
    };
};

const mapDispatchToProps = {
    updateSearchFields,
    loadCurrentShipTos,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderHistorySearchFieldShipToStyles {
    select?: SelectProps;
    wrapper?: SearchFieldWrapperStyles;
}

export const shipToStyles: OrderHistorySearchFieldShipToStyles = {};
const styles = shipToStyles;

class OrderHistorySearchFieldShipTos extends React.Component<Props> {
    componentDidMount() {
        if (!this.props.currentShipTosDataView.value) {
            this.props.loadCurrentShipTos();
        }
    }

    handleChange = (event: React.FormEvent<HTMLSelectElement>) => {
        this.props.updateSearchFields({ customerSequence: event.currentTarget.value });
    };

    render() {
        const shipToOptions = this.props.currentShipTosDataView.value || [];

        return (
            <SearchFieldWrapper extendedStyles={styles.wrapper}>
                <Select
                    label={translate("Ship To")}
                    {...styles.select}
                    value={this.props.parameter.customerSequence}
                    onChange={this.handleChange}
                >
                    {shipToOptions.map(shipTo => (
                        <option key={shipTo.customerSequence} value={shipTo.customerSequence}>
                            {shipTo.label}
                        </option>
                    ))}
                </Select>
            </SearchFieldWrapper>
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderHistorySearchFieldShipTos),
    definition: {
        group: "Order History",
        displayName: "Work Order Ship To",
        allowedContexts: [WorkOrderHistoryPageContext],
    },
};

export default widgetModule;
